import {
  CcfAddEventIcon,
  CcfPopOver,
  CcfPopoverIcon,
  PopOverMenuItem,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { useDispatch } from 'react-redux';
import { commitmentActions } from '../ccf-commitment/ccf-commitment.slice';
import { useSelector } from 'react-redux';
import { getCommitmentItems } from '../global.app.slice';
import { setNewCommitment } from '../ccf-inbox/ccf-inbox.slice';

export interface phoneOBSkills {
  skillId: number;
  skillName: string;
}

export interface CcfAddEventPopoverProps {
  paperProps?: {
    style?: {
      [key: string]: string;
    };
  };
}

/**
 *custom hook to give commitment popover items
 * @returns -addEventPopoverItems, disableAddEvent
 * @example - `useCCfCommitmentPopOverItems()`
 */
export const useCcfCommitmentAddEventPopOverItems = () => {
  const allAddEventPopoverItems = useSelector(getCommitmentItems);
  const userCommitmentPer = { create: true, delete: true };
  const { create: hasCreateCommitmentPermission } = userCommitmentPer;
  const phoneOBSkills: phoneOBSkills[] = [{ skillId: 0, skillName: '' }];

  const addEventPopoverItems =
    !hasCreateCommitmentPermission || !phoneOBSkills?.length
      ? [...allAddEventPopoverItems].filter(
          (item) => item.translationKey !== 'commitment'
        )
      : allAddEventPopoverItems;

  const disableAddEvent = !addEventPopoverItems?.length;

  return { addEventPopoverItems, disableAddEvent };
};

/**
 * CcfCommitments - returns add commitment to schedular app
 * @returns - CcfCommitments
 * @example - `<CcfCommitments />`
 */
export const CcfAddEventPopover = ({ paperProps }: CcfAddEventPopoverProps) => {
  const [translate] = useTranslator();
  const dispatch = useDispatch();

  const { addEventPopoverItems } = useCcfCommitmentAddEventPopOverItems();

  const optionList = {
    menuItems: [
      {
        items: addEventPopoverItems,
      },
    ],
  };

  /**
   * Pop over action handler.
   * @example
   * @returns
   */
  const onPopOverItemSelection = (item: PopOverMenuItem) => () => {
    switch (item.type) {
      case 'commitment':
        // dispatch(commitmentActions.showCommitmentForm(true));  //commented to hide commitment form
        dispatch(setNewCommitment(true)); //open New Commitment View
    }
    return;
  };
  return (
    <CcfPopOver
      onPopOverItemSelection={(item: PopOverMenuItem) =>
        onPopOverItemSelection(item)
      }
      iconComponent={
        <CcfAddEventIcon
          fillColor="#ffffff"
          style={{ width: '18px' }}
          viewBox="0 0 20 20"
        />
      }
      endIconComponent={
        <CcfPopoverIcon style={{ width: '7px' }} viewBox="0 0 7 6" />
      }
      labelComponent={translate('add')}
      optionList={optionList}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      PaperProps={paperProps}
    />
  );
};
